import deleteSocietyValue from 'utils/deleteSocietyValue';

export default [
  {
    icon: 'ni-trash',
    text: 'Eliminar',
    action: deleteSocietyValue,
  },
];
